import { getConversationTasks } from '../services/conversations-service';
import { Conversation } from '../use-chat/use-chat.types';

interface CreateActiveConversationArgs {
  conversationId: string;
  signal?: AbortSignal;
}

export const createActiveConversation = async ({
  conversationId,
  signal,
}: CreateActiveConversationArgs): Promise<Conversation | undefined> => {
  const conversationsMessages = await getConversationTasks(conversationId);

  if (signal?.aborted || !conversationsMessages?.data) {
    return undefined;
  }

  return {
    ...conversationsMessages.data,
    public_copies: [],
  };
};
